<!-- Saldo Items Display -->
@if (saldo && saldo.items && saldo.items.length > 0) {
  <div class="saldo-breakdown">
    <h6 class="breakdown-title">Stavke salda</h6>
    <!-- Unified Card Grid Layout -->
    <div class="saldo-items-grid">
      @for (item of saldo.items; track item) {
        <div class="saldo-item-card">
          <mat-card class="mat-elevation-2">
            <mat-card-content>
              <div class="item-header">
                <h6 class="item-description">{{ item.description }}</h6>
              </div>
              <div class="amounts-container">
                <div class="amount-row">
                  <div class="amount-box contracted">
                    <span class="amount-label">Ugovoreno</span>
                    <span class="amount-value">{{ item.contractedAmount | currency:'EUR' }}</span>
                  </div>
                  <div class="amount-box realized">
                    <span class="amount-label">Realizirano</span>
                    <span class="amount-value">{{ item.realizedAmount | currency:'EUR' }}</span>
                  </div>
                </div>
                <div class="saldo-row">
              <div class="saldo-box" [ngClass]="{
                'savings': item.hasSavings,
                'overrun': item.hasOverrun,
                'balanced': item.isBalanced
              }">
                    <mat-icon class="saldo-icon">
                      {{ item.hasSavings ? 'trending_up' : item.hasOverrun ? 'trending_down' : 'trending_flat' }}
                    </mat-icon>
                    <div class="saldo-content">
                      <span class="saldo-label">Saldo</span>
                      <span class="saldo-value">{{ item.saldo | currency:'EUR' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
    <!-- Total Amounts Summary -->
    <div class="total-amounts-summary">
      <div class="total-amounts-row">
        <div class="total-box contracted">
          <mat-icon class="total-icon">assignment</mat-icon>
          <div class="total-content">
            <span class="total-label">Ukupno ugovoreno</span>
            <span class="total-value">{{ getTotalContracted() | currency:'EUR' }}</span>
          </div>
        </div>
        <div class="total-box realized">
          <mat-icon class="total-icon">done_all</mat-icon>
          <div class="total-content">
            <span class="total-label">Ukupno realizirano</span>
            <span class="total-value">{{ getTotalRealized() | currency:'EUR' }}</span>
          </div>
        </div>
      <div class="total-box saldo" [ngClass]="{
        'savings': saldo.hasSavings,
        'overrun': saldo.hasOverruns,
        'balanced': saldo.isBalanced
      }">
          <mat-icon class="total-icon">
            {{ saldo.hasSavings ? 'trending_up' : saldo.hasOverruns ? 'trending_down' : 'trending_flat' }}
          </mat-icon>
          <div class="total-content">
            <span class="total-label">Ukupan saldo</span>
          <span class="total-value" [ngClass]="{
            'savings': saldo.hasSavings,
            'overrun': saldo.hasOverruns,
            'balanced': saldo.isBalanced
          }">{{ getTotalSaldo() | currency:'EUR' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- No Saldo Items -->
@if (saldo && (!saldo.items || saldo.items.length === 0)) {
  <div class="no-saldo-items">
    <mat-chip-set>
      <mat-chip>
        <mat-icon>info</mat-icon>
        Nema stavki za saldo
      </mat-chip>
    </mat-chip-set>
  </div>
}